import React from 'react'
import PropTypes from 'prop-types'

const TenantFilter = () => {
    return (
        <div className="CallHistoryFilters Filters mb-3">
            <div className="itemFilter mb-3"></div>
            <div className="itemFilter mb-3"></div>
        </div>
    )
}

TenantFilter.propTypes = {
    filters: PropTypes.object,
    onChangeFilter: PropTypes.func
}

export default TenantFilter
